/**
 * Feature Flag Configuration
 *
 * Central configuration for all feature flags in the system.
 */

import { FeatureFlag, type FeatureFlagConfig } from './types';

/**
 * Configuration for all feature flags
 */
export const FEATURE_FLAG_CONFIG: Record<FeatureFlag, FeatureFlagConfig> = {
  [FeatureFlag.ENABLE_SUBSCRIPTIONS]: {
    key: 'ENABLE_SUBSCRIPTIONS',
    name: 'Enable Subscriptions',
    description:
      'Controls visibility of subscription features and pricing plans',
    defaultValue: false,
    envVar: 'ENABLE_SUBSCRIPTIONS',
  },
};

/**
 * Get configuration for a specific feature flag
 */
export function getFeatureFlagConfig(flag: FeatureFlag): FeatureFlagConfig {
  return FEATURE_FLAG_CONFIG[flag];
}

/**
 * Get all feature flag configurations
 */
export function getAllFeatureFlagConfigs(): Record<
  FeatureFlag,
  FeatureFlagConfig
> {
  return FEATURE_FLAG_CONFIG;
}

/**
 * Validate that a string is a valid FeatureFlag
 */
export function isValidFeatureFlag(flag: string): flag is FeatureFlag {
  return Object.values(FeatureFlag).includes(flag as FeatureFlag);
}

/**
 * Get default values for all feature flags
 */
export function getDefaultFeatureFlagValues() {
  return Object.entries(FEATURE_FLAG_CONFIG).reduce(
    (acc, [flag, config]) => {
      acc[flag as FeatureFlag] = config.defaultValue;
      return acc;
    },
    {} as Record<FeatureFlag, boolean>
  );
}
